export const GA_ID = "G-JZCPFRD683";

// Fire a GA4 event. No-op until gtag has loaded; never throws.
export function track(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

// Manual SPA page view (gtag config runs with send_page_view:false).
export function pageview(path) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}
